export class BlockLoopCustomOption {
  id: string;
  text: string;
}
